import React, { useState, useRef } from 'react';
import { Form, Row, Col, Button, Alert, Modal } from 'react-bootstrap';
import CryptoJS from 'crypto-js';
import JSZip from 'jszip';
import ApiMServer from 'services/ApiMServer';

const FileUpload = (props) => {
  const {
    msg,
    type,
    company,
    permission,
    handleGetChart,
    handleAlertModalError,
    handleAlertModalSuccess,
  } = props;

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file || null);
    setFileName(file?.name || '');
  };

  // Validação removida - Upload direto sem verificações

  const handleConfirm = () => {
    setShowConfirm(true);
  }

  const handleConfirmProceed = async () => {
    setShowConfirm(false);
    await handleUpload();
  }

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Arquivo não selecionado!")
      return;
    }

    try {
      // Upload direto sem validações
      const arrayBuffer = await selectedFile.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);
      const curvaEntry = zip.file('curva.txt');
      const curvaSignin = zip.file('assinatura.txt');

      if (!curvaEntry || !curvaSignin) {
        alert('Arquivo inválido: assinatura ou curva ausente.');
        return;
      }

      const signin_date_raw = await curvaSignin.async('string');
      const signin_date = signin_date_raw.replace(/\r\n/g, '\n');
      const fields = extractSignatureFields(signin_date);
      const { date: CHART_DATE, sha256_hex: hashInFile } = fields;

      const curvaBytes = await curvaEntry.async('uint8array');
      const decoder = new TextDecoder('iso-8859-1');
      const latin1_curva = decoder.decode(curvaBytes);

      const chartLines = latin1_curva.split(/\r?\n/);
      const chartPack = convertChartsToJson(chartLines, hashInFile || 'no-hash', CHART_DATE || 'no-date', type);
      await handleSubmitChartPack(chartPack);
    } catch (error) {
      console.error("Erro ao processar arquivo:", error);
      if (handleAlertModalError) {
        handleAlertModalError('Erro ao processar arquivo!');
      }
    }
  };

  const extractSignatureFields = (text) => {
    const cleanHex = (s) => (s || "").replace(/[^0-9a-fA-F]/g, "").toLowerCase();
    
    let sha256_hex = "";
    let signature_hex = "";
    let n_hex = "";
    let e_hex = "";
    let date = "";

    const mSha = /SHA256\s+do\s+arquivo\s*\n([0-9a-fA-F\s]+)/i.exec(text);
    if (mSha) sha256_hex = cleanHex(mSha[1]);

    const mSigBlock = /Assinatura\s+digital[^\n]*\n([\s\S]+?)\nChave\s+Pública/i.exec(text);
    if (mSigBlock) signature_hex = cleanHex(mSigBlock[1]);

    const mPkBlock = /Chave\s+Pública[^\n]*\n([\s\S]+)/i.exec(text);
    if (mPkBlock) {
      const pkLines = mPkBlock[1].split("\n");
      let i = 0;
      while (i < pkLines.length) {
        if (pkLines[i].trim().toUpperCase() === "N") {
          i++;
          let nParts = [];
          while (i < pkLines.length) {
            let line = pkLines[i].trim();
            if (line.toLowerCase() === "e") break;
            if (line && /^[0-9a-fA-F\s]+$/.test(line)) nParts.push(line);
            i++;
          }
          n_hex = cleanHex(nParts.join(""));
          if (i < pkLines.length && pkLines[i].trim().toLowerCase() === "e") {
            i++;
            while (i < pkLines.length) {
              let line = pkLines[i].trim();
              if (line && /^[0-9a-fA-F]+$/.test(line)) {
                e_hex = cleanHex(line);
                break;
              }
              i++;
            }
          }
          break;
        }
        i++;
      }
    }

    const mDate = /\bData:\s*([0-9]{2}\/[0-9]{2}\/[0-9]{4})\b/i.exec(text);
    if (mDate) date = mDate[1];

    return { sha256_hex, signature_hex, n_hex, e_hex, date };
  };

  const getSubstrings = (stringSubject, string1, string2) => {
    let myList = [];
    let intstart = 0;
    const strlength = stringSubject.length;
    let continueloop = true;

    while (intstart < strlength && continueloop) {
      let intindex1 = stringSubject.indexOf(string1, intstart);
      if (intindex1 !== -1) {
        intindex1 += string1.length;
        let intindex2 = stringSubject.indexOf(string2, intindex1);
        if (intindex2 !== -1) {
          const subsequence = stringSubject.substring(intindex1, intindex2);
          myList.push(subsequence);
          intstart = intindex2 + string2.length;
        } else {
          continueloop = false;
        }
      } else {
        continueloop = false;
      }
    }
    return myList;
  };

  const convertChartsToJson = (chart, HASH, CHART_DATE, CHART_TYPE) => {
    let curvas = [];

    for (let line of chart) {
      if (!line) continue;
      let s = line.trim();
      let l = new Set(getSubstrings(s, "<", ">"));
      let j = {};

      l.forEach(i => {
        const regex = new RegExp(`<${i}>(.*?)<${i}>`);
        const result = s.match(regex);
        if (result) {
          let val = result[1];
          if (val.includes(";")) {
            j[i] = val.split(";").map(v => v.trim());
          } else {
            j[i] = val.trim();
          }
        }
      });

      j._id = CryptoJS.SHA256(JSON.stringify(j)).toString();
      j.hash = HASH;
      j.data_pack = CHART_DATE;
      j.chart_type = CHART_TYPE;
      curvas.push(j);
    }
    return curvas;
  };

  const handleSubmitChartPack = async (chartPack) => {
    try {
      const formData = new FormData();
      if (selectedFile) {
        formData.append('file', selectedFile, selectedFile.name);
      }
      formData.append('chartPack', JSON.stringify(chartPack));
      if (company !== undefined && company !== null) formData.append('company', String(company));
      if (type !== undefined && type !== null) formData.append('type', String(type));

      if (selectedFile) {
        const arrayBuffer = await selectedFile.arrayBuffer();
        const zip = await JSZip.loadAsync(arrayBuffer);
        const curvaEntry = zip.file('curva.txt');
        const curvaSignin = zip.file('assinatura.txt');

        if (curvaEntry && curvaSignin) {
          const assinaturaData = await curvaSignin.async('string');
          const curvaData = await curvaEntry.async('string');
          formData.append('assinatura', assinaturaData);
          formData.append('curva', curvaData);
        }
      }

      await ApiMServer.post(`api/v1/chart/up`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (handleGetChart) {
        handleGetChart()
      }
      setSelectedFile(null)
      setFileName("")
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      if (handleAlertModalSuccess) {
        handleAlertModalSuccess('Upload realizado com sucesso!');
      }
    } catch (error) {
      if (handleAlertModalError) {
        handleAlertModalError('Erro ao realizar upload!');
      }
      console.log(error);
    }
  }

  return (
    <Row>
      <Col>
        <Form>
          <Form.Group controlId="formFile" className="mb-2">
            <Form.Control
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              disabled={permission === true ? false : true}
            />
          </Form.Group>
          {fileName && (
            <p className="mb-3">
              <strong>Arquivo Selecionado:</strong> {fileName}
            </p>
          )}
          <Alert variant="warning" className="mb-3 py-2">
            ⚠️ Modo Teste: Upload sem validações - Use com cuidado!
          </Alert>
          <Button
            variant="success"
            onClick={handleConfirm}
            disabled={!selectedFile}
          >
            Enviar
          </Button>
        </Form>
      </Col>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered className="themed-modal">
        <Modal.Header closeButton>
          <Modal.Title>Confirmar envio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {msg || 'Enviar a nova curva substituirá a curva atual!'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmProceed}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};

export default FileUpload;
